import React, { useState } from "react";
import { FaEyeSlash, FaEye } from "react-icons/fa";

const Webhook = () => {
  const [inputPassNew, setInputPassNew] = useState("password");
  const [showNew, setShowNew] = useState(false);

  const handleShowNew = (e) => {
    e.preventDefault();
    setShowNew(!showNew);
    setInputPassNew(inputPassNew === "password" ? "text" : "password");
  };

  const preferences = [
    {
      text: "Receive Webhook response in JSON format",
      name: "json",
      value: "json",
    },
    {
      text: "Enable Webhook retries",
      name: "retries",
      value: "retries",
    },
    {
      text: "Enable webhook for failed transactions",
      name: "failed-transactions",
      value: "failed-transactions",
    },
    {
      text: "Enable V3 Webhooks",
      name: "v3",
      value: "v3",
    },
    {
      text: "Enable Resend Webhook from the Dashboard",
      name: "webhook-dashboard",
      value: "webhook-dashboard",
    },
  ];

  return (
    <div>
      <h1 className="text-2xl font-bold text-navy-blue">Settings - Webhook</h1>
      <div className=" h-[924px] bg-white mt-8 rounded-[10px] p-[3rem]">
        <div className="border border-gray-200 rounded-t-[10px] p-[1rem] pl-7 flex justify-between items-center">
          <p className="text-primary text-xl font-semibold">Test webhooks</p>
          <span>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.5 6.75L9 11.25L13.5 6.75"
                stroke="#464255"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>
        <div className="mt-10 ml-10">
          <div className="flex flex-col">
            <label htmlFor="url" className="text-gray-600 font-semibold">
              URL
            </label>
            <input
              type="text"
              name="url"
              placeholder="Enter url"
              className="bg-form-background w-[348px] h-[50px] mt-2 px-2 rounded-md text-gray-600 focus:outline-none"
            />
          </div>
          <div className="flex flex-col mt-6 relative">
            <label
              htmlFor="secret-hash"
              className="text-gray-600 font-semibold"
            >
              Secret hash
            </label>
            <button
              onClick={handleShowNew}
              className="absolute left-[320px] top-12"
            >
              {showNew ? <FaEyeSlash /> : <FaEye />}
            </button>
            <input
              type={inputPassNew}
              name="secret-hash"
              placeholder="Enter secret hash"
              className="bg-form-background w-[348px] h-[50px] mt-2 px-2 rounded-md text-gray-600 focus:outline-none"
            />
          </div>
          <div className="relative mt-10">
            <span className="absolute left-12 top-[7.8px] text-white">+</span>
            <button className="bg-primary text-white w-[160px] h-[42px] rounded-[10px]">
              Save
            </button>
          </div>
        </div>
        <div className="mt-10 ml-10">
          <p className="text-xl font-normal">Webhook preferences</p>
          <div className="mt-4">
            {preferences.map((preference) => (
              <label
                className="container"
                style={{ fontSize: "14px", fontWeight: 400 }}
              >
                {preference.text}{" "}
                <input
                  type="checkbox"
                  name={preference.name}
                  value={preference.value}
                />
                <span className="checkmark"></span>
              </label>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Webhook;
